<script setup lang="ts">
import type {HTMLAttributes} from "vue"
import {cn} from "@/lib/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
  contentClass?: HTMLAttributes["class"]
  leftClass?: HTMLAttributes["class"]
  centerClass?: HTMLAttributes["class"]
  rightClass?: HTMLAttributes["class"]
}>()
</script>

<template>
  <div
      :class="cn('relative w-fit min-w-0 max-w-full overflow-visible rounded-2xl border border-black/15 bg-black/10 dark:border-white/10 dark:bg-white/8', props.class)"
  >
    <div
        data-slot="glass-item"
        :class="cn('flex max-w-full items-center gap-3.5 rounded-2xl px-3.5 py-3 text-sm text-foreground w-full bg-card', props.contentClass)"
    >
      <div
          v-if="$slots.left"
          data-slot="item-media"
          :class="cn('flex shrink-0 items-center justify-center gap-2 [&_svg]:pointer-events-none', props.leftClass)"
      >
        <slot name="left"/>
      </div>

      <!-- The pill gives way here, not by wrapping: the centre (breadcrumbs) is what shrinks — its
           crumbs collapse from the left, then the page's text gets an ellipsis (BreadcrumbList.vue). -->
      <div
          v-if="$slots.center || $slots.default"
          data-slot="item-content"
          :class="cn('flex min-w-0 flex-initial flex-col gap-1', props.centerClass)"
      >
        <slot name="center">
          <slot/>
        </slot>
      </div>

      <div
          v-if="$slots.right"
          data-slot="item-actions"
          :class="cn('flex min-w-0 items-center gap-2', props.rightClass)"
      >
        <slot name="right"/>
      </div>
    </div>
  </div>
</template>
